import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { ListSalaryStructuresGraphQLRequest, ListSalaryStructuresGraphQLResponse } from '../types';

export const listSalaryStructuresQuery = gql`
  query PayrollListSalaryStructures($input: PayrollListSalaryStructuresInput!) {
    payrollListSalaryStructures(input: $input) {
      data {
        salaryStructures {
          id
          name
          description
          status
          type
          employeeCount
        }
      }
      code
      success
      message
    }
  }
`;

export const listSalaryStructures = (queryVariables: ListSalaryStructuresGraphQLRequest) => {
  return graphQLApi<ListSalaryStructuresGraphQLResponse, ListSalaryStructuresGraphQLRequest>({
    query: listSalaryStructuresQuery,
    queryVariables,
  });
};

export default listSalaryStructures;
